"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _default = {
  componentWillMount: function componentWillMount() {
    (0, _invariant.default)(typeof this.getIntervals === 'function', 'ComponentWithIntervals: component must define a getIntervals function.');
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this._intervals = {};
    var getIntervalsResult = this.getIntervals() || {};
    Object.keys(getIntervalsResult).forEach(function (intervalKey) {
      var _getIntervalsResult$i = getIntervalsResult[intervalKey],
          handler = _getIntervalsResult$i.handler,
          timeout = _getIntervalsResult$i.timeout;
      (0, _invariant.default)(typeof handler === 'function', 'ComponentWithSetIntervals: `%s` handler is not a function.', intervalKey);
      (0, _invariant.default)(typeof timeout === 'number' && timeout >= 0, 'ComponentWithSetIntervals: `%s` timeout is not a positive number.', intervalKey);
      _this._intervals[intervalKey] = setInterval(handler, timeout);
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    var _this2 = this;

    Object.keys(this._intervals).forEach(function (key) {
      return clearInterval(_this2._intervals[key]);
    });
  }
};
exports.default = _default;
module.exports = exports.default;